import { useEffect, useState } from 'react';

interface UTMBannerProps {
  source?: string;
  medium?: string;
  campaign?: string;
  trafficSource?: string;
  onDismiss: () => void;
}

export default function UTMBanner({ source, medium, campaign, trafficSource, onDismiss }: UTMBannerProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animate in after mount
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(onDismiss, 300);
  };

  const getSourceIcon = () => {
    const lowerSource = (source || trafficSource || '').toLowerCase();
    if (lowerSource.includes('google')) return 'ri-google-fill';
    if (lowerSource.includes('facebook') || lowerSource.includes('fb')) return 'ri-facebook-fill';
    if (lowerSource.includes('instagram')) return 'ri-instagram-fill';
    if (lowerSource.includes('linkedin')) return 'ri-linkedin-fill';
    if (lowerSource.includes('organic') || lowerSource.includes('search')) return 'ri-search-line';
    if (lowerSource.includes('referral')) return 'ri-links-line';
    return 'ri-global-line';
  };

  const getSourceColor = () => {
    const lowerSource = (source || trafficSource || '').toLowerCase();
    if (lowerSource.includes('google')) return 'from-[#1A3A52] to-[#2D5A7A]';
    if (lowerSource.includes('facebook')) return 'from-[#2D6A4F] to-[#1E4D38]';
    if (lowerSource.includes('instagram')) return 'from-pink-500 to-rose-600';
    if (lowerSource.includes('linkedin')) return 'from-[#1A3A52] to-[#2D5A7A]';
    return 'from-[#D97642] to-[#C26638]';
  };

  const getMessage = () => {
    if (campaign) {
      return `Welcome from our ${campaign} campaign!`;
    }
    if (source) {
      return `Welcome from ${source}!`;
    }
    if (trafficSource) {
      return `Welcome from ${trafficSource}!`;
    }
    return 'Welcome to Hoosier Life Insurance!';
  };

  return (
    <div
      className={`fixed top-20 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-[600px] transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
      }`}
    >
      <div className={`bg-gradient-to-r ${getSourceColor()} rounded-xl shadow-2xl p-4 md:p-5`}>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 shrink-0">
            <i className={`${getSourceIcon()} text-[24px] text-white`}></i>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-[15px] md:text-[16px] font-bold text-white mb-1">
              {getMessage()}
            </h3>
            <p className="text-[13px] md:text-[14px] text-white/90">
              Get your free quote today — we're here to help Indianapolis families find the right coverage.
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors shrink-0 cursor-pointer"
            aria-label="Dismiss banner"
          >
            <i className="ri-close-line text-[20px] text-white"></i>
          </button>
        </div>
      </div>
    </div>
  );
}